
































































































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import EventMixin from '@/mixins/EventMixin';
import FieldDefs from './FieldDefs';
import { EventFilter } from '@/interfaces';
import moment from 'moment';
import { VForm } from '@/interfaces';
import { Getter, Mutation } from 'vuex-class';

@Component
export default class QuotesOverview extends Mixins(OverviewMixin, EventMixin) {
  public get theForm() {
    return (this.$refs.form as unknown) as VForm;
  }
  public tableCfg = FieldDefs;
  public fixedFilter = this.getTableCfg(this.tableCfg, 'fixedFilter');
  // public orderDocTypeId = this.getTableCfg(this.tableCfg, 'orderDocTypeId');
  public exportDialogValue = false;

  public version = 1;
  public eventFilter: EventFilter = {};

  @Getter('getOrderDocEventId')
  public getOrderDocEventId!: () => number;

  @Mutation('setOrderDocEventId')
  public setOrderDocEventId;

  // Set default month to previous month
  public monthPicker = moment()
    .subtract(1, 'month')
    .format('YYYY-MM');
  public formValid = false;

  public setFilter(statusId) {
    this.eventFilter.last_orderdoceventtype_id = statusId;
    this.filterChanged();
  }

  public filterChanged() {
    this.version += 1;
    this.setOrderDocEventId(this.eventFilter.last_orderdoceventtype_id);
  }

  public async exportDialogOverview() {
    if (!this.formValid) {
      this.theForm.validate();
    } else {
      const filter = {
        creationdate_ge: moment(this.monthPicker)
          .startOf('month')
          .format('YYYY-MM-DD'),
        creationdate_le: moment(this.monthPicker)
          .endOf('month')
          .format('YYYY-MM-DD')
      };
      await this.uploadOverview({ filter });
      this.exportDialogValue = false;
    }
  }

  public async exportFilteredOverview() {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.uploadOverview(data);
  }

  public async uploadOverview(data) {
    const response = await this.api.postAction(this.$store, '/orderdocs/export_bwise', data);
  }

  public created() {
    this.eventFilter.last_orderdoceventtype_id = this.getOrderDocEventId();
  }
}
